import { gql } from 'apollo-angular';

export const RemoveActivityDocument = gql(/* GraphQL*/ `mutation removeActivity($activityId: Int!) {
  removeActivity(activityId: $activityId)
}
`);
